import { Box, Card, CardContent, Chip, Grid, Paper, Stack, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { getVendorDues } from "services/vendorDashboard";
import { getDbFormat, tConvert } from "utils/common";

export default function VendorDues({pageFilters}) {
  
  const { enqueueSnackbar } = useSnackbar();
  const [dues, setDues] = useState(null);

  const getDues = useCallback((pageFilters) => {
    const [from, to ]= pageFilters.filterDates;
    const data = {
      from: getDbFormat(from), to: getDbFormat(to), propertyId: pageFilters.library.id, propertyType: 'LIBRARY'
    };
    getVendorDues(data).then(({response, error}) => {
      if(response){
        setDues(response);
      } else {
        setDues([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);
  
  useEffect(() => {
    if(pageFilters){
      getDues(pageFilters);
    }
  }, [getDues, pageFilters]);
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 2, minHeight: "calc(100vh - 100px )" }} elevation={0}>
     
      <Box noValidate>
        <Grid container columnSpacing={3} rowSpacing={2} >
          {(dues || []).map(({user={}, bookingTransaction={}, seatCount, toTime, fromTime, seatIds=[], library={}}, index) => (
            <Grid item xs={12} sm={6} md={6} xl={3} lg={4} key={index}>
              <Card sx={{height: '100%'}}>
                <CardContent sx={{backgroundColor: '#f8f8f8', height: '100%'}}>
                  <Typography  variant="subtitle2" component="p" noWrap color="#000" fontWeight={600}>
                    {user?.displayName}
                  </Typography>
                  <Typography gutterBottom variant="caption" component="div" color="text.secondary" >
                    {library?.name}
                  </Typography>
                  <Typography variant="body2" color="secondaryText">
                    {seatCount} {`${seatCount === 1 ? 'Seat': 'Seats'} seats`}: {(seatIds||[]).join(', ')}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" fontWeight={500}>
                    {tConvert(fromTime)} - {tConvert(toTime)}
                  </Typography>

                  <Stack justifyContent="space-between" direction={{xs: "column", md: "row"}} alignItems="center" gap={2}>
                    <Typography variant="body1"  fontWeight={500} mt={1.4}>
                      Amount due: Rs.{bookingTransaction?.amountDue}
                    </Typography> 
                    <Typography variant="caption"  >
                      <Chip color="warning" label={`Due on: ${bookingTransaction?.dueDate}`} />
                    </Typography>
                  </Stack>

                </CardContent>
              </Card>
            </Grid>
          ))}
          {dues?.length === 0 ? (
            <Typography color="error" variant="h5" component="h5"> No data found</Typography>
          ): null}
        </Grid>
      </Box>
    </Paper>
  );
}
